"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var cfgRouter = {
  path: '/cfg',
  component: _layout.default,
  redirect: '/cfg/sys_config',
  name: 'cfg',
  meta: {
    title: '配置',
    icon: 'base'
  },
  children: [{
    path: 'bus_config',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/cfg/BusConfigIndex'));
      });
    },
    name: 'bus_config',
    meta: {
      title: '业务配置'
    }
  },
  // {
  //   path: 'storage_config',
  //   component: () => import('@/views/cfg/StorageConfigIndex'),
  //   name: 'storage_config',
  //   meta: { title: '对象存储', icon: '' }
  // }, {
  //   path: 'ai_config',
  //   component: () => import('@/views/cfg/AiConfigIndex'),
  //   name: 'ai_config',
  //   meta: { title: 'AI配置' }
  // },
  {
    path: 'sso_cfg',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/cfg/SsoCfgIndex.vue'));
      });
    },
    name: 'sso_cfg',
    meta: {
      title: '单点登录'
    }
  }, {
    path: 'global_config',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/cfg/GlobalConfigIndex.vue'));
      });
    },
    name: 'global_config',
    meta: {
      title: '全局配置'
    }
  }]
};
var _default = exports.default = cfgRouter;